<template>
  <div class="page-wrapper">
    <div class="container">
      <div class="row nav-container">
        <ul>
          <li><a href="#/admin/home/">메인</a></li>
          <li><a href="#/admin/checkin/">체크인</a></li>
          <li><a href="#/admin/settings/">세팅</a></li>
          <li><a class="active" href="#/admin/customers/">업체</a></li>
          <li><a href="#/admin/forwarders/">파트너</a></li>
          <li><a href="#/admin/users/">사용자</a></li>
          <li>
            <div class="logout" v-on:click="logout">로그아웃</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <h4>Customer List
        <div v-show="newCustomer == false" class="btn btn-primary" v-on:click="openNewCustomerForm()">Add</div>
      </h4>
      <table class="table">
        <tr>
          <th>#</th>
          <th>Code</th>
          <th>User Name</th>
          <th>Title</th>
          <th>Email</th>
          <th>Contact</th>
          <th>Address</th>
          <th>Base Price</th>
          <th>Unit Price</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in customers">
          <td class="text-left">{{index+1}}</td>
          <td class="text-left">{{item.code}}</td>
          <td class="text-left">{{item.user_name}}</td>
          <td class="text-left">{{item.title}}</td>
          <td class="text-left">{{item.contact_email}}</td>
          <td class="text-left">{{item.contact_mobile}}</td>
          <td class="text-left">{{item.address_1}} {{item.address_2}} {{item.address_3}} {{item.post_code}}</td>
          <td>£{{(item.base_price/100).toFixed(2)}}</td>
          <td>£{{(item.price/100).toFixed(2)}}</td>
          <td>
            <button v-show="newCustomer == false" type="button" class="btn btn-primary"
                    v-on:click="editCustomer(index)">Edit
            </button>
          </td>

        </tr>
      </table>
    </div>
    <div class="new-item-form" v-if="newCustomer != false">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h4 v-if="newCustomer.id == 0">신규등록</h4>
            <h4 v-if="newCustomer.id > 0">업체수정 {{newCustomer.title}}</h4>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-6">
            <div class="container">
              <div class="form-group row">
                <div class="col-4">아이디</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.user_name"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">CODE</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.code" :disabled="newCustomer.id>0"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">업체명</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.title" placeholder="Title"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">Email</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.contact_email" placeholder="Email"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">Contact</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.contact_mobile" placeholder="Contact"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">기본요금</div>
                <div class="col-8">
                  <input type="number" class="form-control" v-model="newCustomer.base_price" placeholder="Base Price"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">추가요금</div>
                <div class="col-8">
                  <input type="number" class="form-control" v-model="newCustomer.price" placeholder="Price"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="container">
              <div class="form-group row">
                <div class="col-4">POST CODE</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.post_code" placeholder="Post Code"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4">Address:</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.address_1" placeholder="Address Line 1"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4"></div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.address_2" placeholder="Address Line 2"/>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-4"></div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.address_3" placeholder="Address Line 3"/>
                </div>
              </div>

              <div class="form-group row">
                <div class="col-4">전자상거래 유형</div>
                <div class="col-8">
                  <select v-model="newCustomer.registeredType" class="form-control">
                    <option value="A">해외판매자, 직접구매</option>
                    <option value="B">구매대행, 배송대행</option>
                    <option value="C">판매중개자</option>
                    <option value="Z">파악불가</option>
                  </select>
                </div>
              </div>
              <div class="form-group row" v-if="newCustomer.registeredType !== 'Z'">
                <div class="col-4">
                  <span v-if="newCustomer.registeredType === 'A'">해외판매자 부호</span>
                  <span v-if="newCustomer.registeredType === 'B'">구매대행, 배송대행 부호</span>
                  <span v-if="newCustomer.registeredType === 'C'">판매중개자 부호</span>
                </div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.registeredCode"/>
                </div>
              </div>
              <div class="form-group row" v-if="newCustomer.registeredType !== 'Z'">
                <div class="col-4">
                  <span v-if="newCustomer.registeredType === 'A'">해외판매자 상호</span>
                  <span v-if="newCustomer.registeredType === 'B'">구매대행, 배송대행 상호</span>
                  <span v-if="newCustomer.registeredType === 'C'">판매중개자 상호</span>
                </div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.registeredName"/>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="container">
              <div class="form-group row">
                <div class="col-4">Printer</div>
                <div class="col-8">
                  <input type="text" class="form-control" v-model="newCustomer.printer_url" placeholder="Printer URL"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="btn btn-secondary" v-on:click="closeCustomerForm()">Close</div>
          </div>
          <div class="col-6">
            <div v-show="newCustomer.id == 0" class="btn btn-primary" v-on:click="submitCustomerForm()">Create</div>
            <div v-show="newCustomer.id > 0" class="btn btn-primary" v-on:click="submitCustomerForm()">Update</div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>
<script>
    import Router from '../router';
    import VModal from '../router';
    import axios from 'axios';

    export default {
        name: 'CustomerManagement',

        data() {
            return {
                msg: 'Admin Customers',
                user: false,
                customers: [],
                partners: [],
                newCustomer: false,
                newPartner: false,
            }
        },
        created: function () {
            if(localStorage.getItem('id') == undefined || localStorage.getItem('id') == null || localStorage.getItem('id') === '') {
                Router.push('/admin');
                return;
            }
            this.$data.user = {
                "id": localStorage.getItem('id'),
            }
            this.getCustomers();
            registerBackKeyHandler(this.backHandler);

        },
        beforeDestroy() {
            registerBackKeyHandler(false);
        },
        mounted: function () {

        },
        methods: {
            backHandler: function () {
                console.log("Admin Main back pressed");
                if (this.$data.newCustomer != false) {
                    this.$data.newCustomer = false;
                    return;
                }

            },
            logout: function () {
                var self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem('id');
                localStorage.removeItem('email');
                localStorage.removeItem('level');
                localStorage.removeItem('admin');
                localStorage.removeItem('password');
                Router.push('/admin');
            },
            showModal: function (title, message) {
                console.log("show modal " + title + " : " + message);
                this.$modal.show('dialog', {
                    title: title,
                    text: message,
                    buttons: [
                        {title: 'Close'}
                    ]
                })
                return;
            },
            getCustomers: function () {
                var self = this;
                var url = process.env.APP_URL + 'api/get_customers.php?customer_id=' + this.$data.user.id + '&state=0';
                axios.get(url)
                    .then(response => {
                        console.log("Get Pending");
                        console.log(response);

                        var data = response.data;
                        if (data.success == true) {
                            self.$data.customers = data.list.customer;
                            self.$data.partners = data.list.partner;
                        } else {

                        }
                    })
                    .catch(error => {

                    });
            },
            openNewCustomerForm: function () {
                this.$data.newCustomer = {
                    id: 0,
                    code: '',
                    user_name: '',
                    title: '',
                    post_code: '',
                    address_1: '',
                    address_2: '',
                    address_3: '',
                    contact_mobile: '',
                    contact_email: '',
                    base_price: 0,
                    price: 0,
                    printer_url:'',
                    registeredType:'Z',
                  registeredCode:'',
                  registeredName:'',

                };
            },
            editCustomer: function (index) {
                this.$data.newCustomer = this.$data.customers[index];

            },
            closeCustomerForm: function () {
                this.$data.newCustomer = false;
            },
            verifyCustomerForm: function () {
                if (this.$data.newCustomer.id == 0) {
                    if (this.$data.newCustomer.user_name.length < 3) {
                        this.showModal("ERROR", "ID must be longer than 4");
                        return false;
                    }
                    if (this.$data.newCustomer.code.length != 4) {
                        this.showModal("ERROR", "Customer Code must be 4 characters");
                        return false;
                    }
                }
                if (this.$data.newCustomer.title.length == 0) {
                    this.showModal("ERROR", "User Title");
                    return false;
                }
                if (this.$data.newCustomer.post_code.length == 0) {
                    this.showModal("ERROR", "Enter Post Code");
                    return false;
                }
                if (this.$data.newCustomer.address_1.length == 0) {
                    this.showModal("ERROR", "Enter Address line 1");
                    return false;
                }
                if (this.$data.newCustomer.address_2.length == 0) {
                    this.showModal("ERROR", "Enter Address Line 2");
                    return false;
                }
                if (this.$data.newCustomer.contact_mobile.length == 0) {
                    this.showModal("ERROR", "Enter Customer Phone number");
                    return false;
                }
                if (this.$data.newCustomer.contact_email.length == 0) {
                    this.showModal("ERROR", "Enter Customer Email address");
                    return false;
                }
                if (this.$data.newCustomer.base_price == 0) {
                    this.showModal("ERROR", "기본요금을 입력해주세요");
                    return false;
                }
                if (this.$data.newCustomer.price == 0) {
                    this.showModal("ERROR", "추가요금을 입력해주세요");
                    return false;
                }

                return true;
            },
            submitCustomerForm: function () {
                if (this.verifyCustomerForm() == false) {
                    return;
                }
                let data = {
                    "title": this.$data.newCustomer.title,
                    "user_name": this.$data.newCustomer.user_name,
                    "contact_email": this.$data.newCustomer.contact_email,
                    "contact_mobile": this.$data.newCustomer.contact_mobile,
                    "post_code": this.$data.newCustomer.post_code,
                    "address_1": this.$data.newCustomer.address_1,
                    "address_2": this.$data.newCustomer.address_2,
                    "address_3": this.$data.newCustomer.address_3,
                    "base_price": this.$data.newCustomer.base_price,
                    "price": this.$data.newCustomer.price,
                    "printer_url":this.$data.newCustomer.printer_url,
                  "registeredType":this.$data.newCustomer.registeredType,
                  "registeredCode":this.$data.newCustomer.registeredCode,
                  "registeredName":this.$data.newCustomer.registeredName,

                    "type": "customer",
                };
                console.log(data);
                //return;
                let self = this;
                if (this.$data.newCustomer.id == 0) {
                    data["code"] = this.$data.newCustomer.code;
                    data["user_name"] = this.$data.newCustomer.user_name;
                    axios.post(process.env.APP_URL + 'api/create_customer.php', data)
                        .then(response => {
                            console.log(response);
                            let data = response.data;
                            if (data.success == true) {
                                self.$data.customers.push(data.item);
                                self.$data.newCustomer = false;
                            } else {
                                self.showModal("ERROR", "Failed to create new AWB " + data.message);
                            }
                        })
                        .catch(error => {

                        })
                } else if (this.$data.newCustomer.id > 0) {
                    data["id"] = this.$data.newCustomer.id;
                    var postData = {
                        "table": "customer_table",
                        "data": data,
                    };
                    axios.post(process.env.APP_URL + 'api/update.php', postData)
                        .then(response => {
                            console.log(response);
                            var data = response.data;
                            if (data.success == true) {
                                console.log("Successful update");
                                for (var i = 0; i < self.$data.customers.length; i++) {
                                    if (self.$data.customers[i].id == data.item.id) {
                                        self.$data.customers[i] = data.item;
                                        break;
                                    }
                                }
                                console.log("Set Customer to false");
                                self.$data.newCustomer = false;
                            } else {
                                self.showModal("ERROR", "Failed to update " + data.message);
                            }
                        })
                        .catch(error => {

                        })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AdminCustomers.vue